var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 1.51289V4.26659C8.33341 4.63995 8.33341 4.82664 8.40608 4.96925C8.46999 5.09469 8.57198 5.19667 8.69742 5.26059C8.84003 5.33325 9.02671 5.33325 9.40008 5.33325H12.1538M12.3334 6.65874V11.4666C12.3334 12.5867 12.3334 13.1467 12.1154 13.5746C11.9237 13.9509 11.6177 14.2569 11.2414 14.4486C10.8136 14.6666 10.2535 14.6666 9.13341 14.6666H4.86675C3.74664 14.6666 3.18659 14.6666 2.75877 14.4486C2.38244 14.2569 2.07648 13.9509 1.88473 13.5746C1.66675 13.1467 1.66675 12.5867 1.66675 11.4666V4.53325C1.66675 3.41315 1.66675 2.85309 1.88473 2.42527C2.07648 2.04895 2.38244 1.74299 2.75877 1.55124C3.18659 1.33325 3.74664 1.33325 4.86675 1.33325H7.00793C7.49711 1.33325 7.7417 1.33325 7.97188 1.38851C8.17595 1.43751 8.37104 1.51831 8.54998 1.62797C8.75182 1.75166 8.92477 1.92461 9.27067 2.27051L11.3962 4.39599C11.7421 4.7419 11.915 4.91485 12.0387 5.11668C12.1484 5.29563 12.2292 5.49072 12.2782 5.69479C12.3334 5.92496 12.3334 6.16955 12.3334 6.65874Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteGray);
export default __webpack_public_path__ + "static/media/note-gray.8b709c5d37e627dc9b53d2b60d2c433a.svg";
export { ForwardRef as ReactComponent };